export function FileUploadIcon(): JSX.Element {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M33.4557 12.341C33.4693 12.1094 33.4769 11.8745 33.4769 11.6313C33.4845 6.51581 30.1433 1.99791 25.2499 0.507106C19.1158 -1.36173 12.628 2.09592 10.7592 8.23004C10.5864 8.22116 10.4197 8.21638 10.2551 8.21638C4.59706 8.21638 0.0102539 12.8032 0.0102539 18.4613C0.0102539 24.1193 4.59706 28.7061 10.2551 28.7061H16.4096C16.7868 28.7061 17.0926 28.4003 17.0926 28.0231C17.0926 27.646 16.7868 27.3401 16.4096 27.3401H10.2551C5.35142 27.3401 1.37624 23.365 1.37624 18.4613C1.37624 13.5575 5.35142 9.58236 10.2551 9.58236C10.57 9.58321 10.8846 9.60037 11.1977 9.63358C11.5332 9.66167 11.8409 9.44576 11.9285 9.12066C13.0726 4.55545 17.1798 1.357 21.8862 1.36631C27.5443 1.37741 32.1221 5.97326 32.1109 11.6313C32.1127 12.0574 32.085 12.4829 32.0282 12.9051C32.0241 12.9357 32.022 12.9666 32.022 12.9974C32.0221 13.3746 32.3279 13.6803 32.7051 13.6803H32.7939C36.5659 13.6803 39.6238 16.7382 39.6238 20.5102C39.6238 24.2823 36.5659 27.3401 32.7939 27.3401H24.6437C24.2665 27.3401 23.9607 27.646 23.9607 28.0231C23.9607 28.4003 24.2665 28.7061 24.6437 28.7061H32.7939C37.065 28.707 40.6207 25.4277 40.9648 21.1704C41.3294 16.6588 37.9674 12.7056 33.4557 12.341Z"
          fill="#5353F6"
        />
        <path
          d="M28.7094 20.9244L20.4992 12.7148L12.2889 20.9244L13.2554 21.8908L19.8162 15.3293V41.0003H21.1822V15.3293L27.743 21.8908L28.7094 20.9244Z"
          fill="#5353F6"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
